export class Modal {
    private static _modals = [];
    private readonly modalElement: HTMLDivElement;

    constructor(data: string | HTMLElement) {
        if (typeof data == "object") {
            data = data.outerHTML;
        }
        this.modalElement = document.querySelector('.modal-wrapper');
        this.modalElement.querySelector('[data-modal-close]').addEventListener('click', event => {
            this.close();
        });
        this.modalElement.addEventListener('click', event => {
            if (event.target !== this.modalElement) {
                return;
            }
            this.close();
        });
        document.addEventListener('keydown', (event) => {
            if (event.key === 'Escape') {
                this.close();
            }
        });

        const modalContent = this.modalElement.querySelector('.modal-content');
        modalContent.innerHTML = '';
        modalContent.innerHTML = data;

    }

    open() {
        Modal.closeAll();
        this.modalElement.classList.add('visible');
        Modal._modals.push(this.modalElement);
    }

    close() {
        this.modalElement.classList.remove('visible');

        Modal._modals.forEach((item, index) => {
            if (item === this.modalElement) {
                Modal._modals.splice(index, 1);
            }
        });
    }

    static closeAll() {
        Modal._modals.forEach((item, index) => {
            item.classList.remove('visible');
            Modal._modals.splice(index, 1);
        });
    }
}
